import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  position: relative;

  display: flex;
  flex-direction: column;

  margin-bottom: 12px;
`;
